module.exports = __webpack_public_path__ + "img/flowChart.b7c65c15.png";